export type PaymentReturnParams = {
  caseNumber: string;
  transactionId: string;
  responseCode: string;
  paymentItemType: string;
  paymentToken: string;
  providerType: number;
};

// 0 = Nets, 1 = Swish, 2 = Neonomics
const resolveProviderType = (params: URLSearchParams): number => {
  if (params.has('neonomicsTransactionId')) return 2;
  if (params.has('SwishPaymentTransId')) return 1;
  return 0;
};

export const getPaymentReturnParams = (search: string): PaymentReturnParams => {
  const params = new URLSearchParams(search);
  const getParam = (...keys: string[]) => keys.map((k) => params.get(k)).find((v) => v !== null) ?? '';

  const caseNumber = params.get('caseNumber') ?? '';
  const paymentToken =
    params.get('paymentToken') ?? sessionStorage.getItem(`paymentToken:${caseNumber}`) ?? '';

  return {
    caseNumber,
    transactionId: getParam('NetsPaymentTransId', 'SwishPaymentTransId', 'neonomicsTransactionId'),
    responseCode: getParam('responseCode', 'status'),
    paymentItemType: getParam('paymentItemType'),
    paymentToken,
    providerType: resolveProviderType(params),
  };
};
